<template>
  <div>
    <div v-if="loading" class="lds-ring-grey">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <canvas id="pie-chart" width="200" height="200" :class="{ hidden: loading }"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  props: {
    data: {
      type: Array,
    },

    labels: {
      type: Array,
    },
  },

  data() {
    return {
      context: null,
      chart: null,
      loading: true,
    };
  },

  watch: {
    labels(labels) {
      if (this.chart) {
        this.loading = true;
        this.chart.data.datasets[0].data = this.data;
        this.chart.data.labels = labels;
        this.chart.update();
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },

  mounted() {
    this.initChart();
  },

  methods: {
    initChart() {
      this.context = document.getElementById('pie-chart').getContext('2d');
      this.chart = new Chart(this.context, {
        type: 'pie',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: [300, 50, 100, 20],
              backgroundColor: ['#4696D7', '#1C236B', '#36A5A2', '#88D388'],
            },
          ],
        },
      });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
canvas.hidden {
  opacity: 0;
  height: 0;
}
</style>
